'use client'

import { Col, Skeleton, Separator, Typography } from '@repo/ui/components'
import { useTranslate } from '@repo/shared/hooks'
import { PropertyCard } from './dashboard.property-card'
import { useAgentListMyProjects } from '@repo/services'
import { PropertiesEmptyState } from './dashboard.properties.empty-state'
import { Fragment } from 'react'

export const MyProperties = () => {
  const { t } = useTranslate()

  const { data, isLoading } = useAgentListMyProjects({
    skip: 0,
    limit: 3,
  })
  const projects =
    data?.pages.flatMap((page) => page.data?.projects || []) || []
  const posts = data?.pages.flatMap((page) => page.data?.posts || []) || []

  const projectItems = projects.map((project) => ({
    post: posts.find((post) => post.projectID === project.id),
    project: project,
    agent: undefined,
    link: undefined,
  }))
  return (
    <Col className='gap-3xl w-full md:border  md:border-neutral-surface-dark rounded-sm md:p-md'>
      <Typography
        variant='h3'
        size='md'
        weight='bold'
        color='text-neutral-main'
        className='p-md md:p-0'
      >
        {t('dashboardAgent_my_properties')}
      </Typography>

      <Col className='flex-1'>
        {projectItems.map((projectItem, index) => (
          <Fragment key={projectItem.project.id}>
            <PropertyCard
              key={index}
              property={projectItem.project}
              post={projectItem.post}
              layout='dashboard'
            />
            {index !== projectItems.length - 1 && <Separator />}
          </Fragment>
        ))}

        {isLoading && (
          <Col className='gap-md px-md'>
            {Array.from({ length: 10 }).map((_, index) => (
              <Skeleton
                key={index}
                className='w-full h-20  bg-neutral-surface-light rounded-md '
              />
            ))}
          </Col>
        )}

        {projects.length === 0 && <PropertiesEmptyState />}
      </Col>
    </Col>
  )
}
